<app-lms-modal-frame [title]="'Branch Report by Area'" [pageHeadWidth]="600">
  <div modal-body class="p-0">
    <section class="loans-section">

      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <table class="loans-table" #TABLE>
            <caption>
              {{ areaName ? 'Area: ' + areaName : 'All Areas' }}
              <span *ngIf="startDate && endDate"> &mdash; {{ startDate }} to {{ endDate }}</span>
            </caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">Area</th>
                <th scope="col">Branch</th>
                <th scope="col">User</th>
                <th scope="col" class="amount">Loan Count</th>
                <th scope="col" class="amount">Sum of Capital (R)</th>
                <th scope="col" class="amount">New Loan Count</th>
                <th scope="col" class="amount">Sum of New Capital (R)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of branchReportByAreaList | paginate: config">
                <td>{{ row.area }}</td>
                <td>{{ row.branch }}</td>
                <td>{{ row.user }}</td>
                <td class="amount">{{ row.countOfLoanNumber }}</td>
                <td class="amount">{{ row.sumOfCapital | number: '1.2-2' }}</td>
                <td class="amount">{{ row.countOfLoanNumberNew }}</td>
                <td class="amount">{{ row.sumOfCapitalNew | number: '1.2-2' }}</td>
              </tr>
              <tr *ngIf="branchReportByAreaList.length === 0">
                <td colspan="7" class="text-center text-muted py-3">No data available.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator-row">
          <pagination-controls [id]="config.id || 'branch-report-by-area-pager'"
            (pageChange)="config.currentPage = $event"></pagination-controls>
        </div>
      </div>

    </section>
  </div>

  <div modal-actions class="action-bar">
    <button class="btn-action btn-export" type="button" (click)="exportToExcel()">
      <i class="fas fa-file-excel fa-fw"></i> Export to Excel
    </button>
    <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
  </div>
</app-lms-modal-frame>
